export default "__VITE_ASSET__DLqPTkSk__"